import { createAction, props, union } from '@ngrx/store';
import { InfChgSaveQueryI } from 'src/app/api/inf-chg-save/inf-chg-save.query.int';
import { InfChgSaveI } from 'src/app/api/inf-chg-save/inf-chg-save.result.int';
import { SharedErrorObjectI } from 'src/app/shared/models/shared/shared-error-object.interface';

/* eslint-disable max-len */
export const error = createAction('[INF CHG / Save] Error', props<{ error: SharedErrorObjectI }>());
export const load = createAction('[INF CHG / Save] Load', props<{
    query: InfChgSaveQueryI
}>());
export const received = createAction('[INF CHG / Save] Received', props<{
    result: InfChgSaveI;
}>());
export const reset = createAction('[INF CHG / Save] Reset', props<Record<string, unknown>>());

const all = union({
    error,
    load,
    received,
    reset,
});
export type Actions = typeof all;
